<div class="dialog" data-testid="confirmation-dialog">
  <button class="dialog__close" (click)="closeDialog(false)">
    <fr8bot-ui-icon name="menu-x" [size]="16" />
  </button>

  <div class="dialog-confirmation-wrapper">
    <div class="dialog-confirmation-wrapper__inner">
      @if (data.icon) {
        <div
          class="dialog-confirmation-wrapper__mainIcon dialog-confirmation-icon"
          [ngClass]="data.dialogStyle"
        >
          <fr8bot-ui-icon [name]="data.icon" [size]="50" />
        </div>
      }

      <div class="dialog__title">
        <span class="dialog__title-title" data-testid="confirmation-dialog-title">{{
          data.titleText | translate
        }}</span>
        @if (data.descriptionText) {
          <span class="dialog__title-subtitle">{{ data.descriptionText | translate }}</span>
        }
      </div>

      @if (data.highlightText) {
        <div class="dialog-confirmation-wrapper__subtitleInfo">
          {{ data.highlightText | translate }}
        </div>
      }

      @if (data.alternateButtonText || data.cancelButtonText || data.submitButtonText) {
        <div class="dialog__action dialog-confirmation-wrapper__action dialog-confirmation-action">
          @if (data.alternateButtonText) {
            <fr8bot-ui-button
              (click)="closeDialog()"
              class="dialog__action-btnTwo dialog-confirmation-action__button"
              type="secondary"
            >
              {{ data.alternateButtonText | translate }}
            </fr8bot-ui-button>
          }

          @if (data.cancelButtonText) {
            <fr8bot-ui-button
              (click)="closeDialog(false)"
              class="dialog__action-btnTwo dialog-confirmation-action__button"
              type="secondary"
              data-testid="confirmation-dialog-cancel"
            >
              {{ data.cancelButtonText | translate }}
            </fr8bot-ui-button>
          }

          @if (data.submitButtonText) {
            <fr8bot-ui-button
              (click)="closeDialog(true)"
              class="dialog__action-btnTwo dialog-confirmation-action__button"
              type="primaryCut"
              data-testid="confirmation-dialog-submit"
            >
              {{ data.submitButtonText | translate }}
            </fr8bot-ui-button>
          }
        </div>
      }
    </div>
  </div>
</div>
